var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconAluno(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 20V32M12 25V32C12 33.5913 13.2643 35.1174 15.5147 36.2426C17.7652 37.3679 20.8174 38 24 38C27.1826 38 30.2348 37.3679 32.4853 36.2426C34.7357 35.1174 36 33.5913 36 32V25M42.8401 21.8442C43.1981 21.6863 43.502 21.4268 43.7139 21.0978C43.9259 20.7689 44.0368 20.385 44.0327 19.9937C44.0287 19.6024 43.9099 19.2209 43.6912 18.8964C43.4724 18.5719 43.1633 18.3187 42.8021 18.1682L25.6601 10.3602C25.139 10.1225 24.5729 9.99951 24.0001 9.99951C23.4273 9.99951 22.8612 10.1225 22.3401 10.3602L5.20008 18.1602C4.84402 18.3162 4.54112 18.5725 4.32842 18.8979C4.11572 19.2232 4.00244 19.6035 4.00244 19.9922C4.00244 20.3809 4.11572 20.7612 4.32842 21.0866C4.54112 21.412 4.84402 21.6683 5.20008 21.8242L22.3401 29.6402C22.8612 29.8779 23.4273 30.0009 24.0001 30.0009C24.5729 30.0009 25.139 29.8779 25.6601 29.6402L42.8401 21.8442Z",
    stroke: "#022A59",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAluno);
export default __webpack_public_path__ + "static/media/icon-aluno.c26a848e.svg";
export { ForwardRef as ReactComponent };